define('components/photoset/layouts/fitColumn/layout', [
    'components/photoset/complexNumber',
    'components/photoset/layouts/fitColumn/row',    
    'components/photoset/layouts/fitColumn/processors/balance',
    'components/photoset/layouts/fitColumn/processors/compact',
    'components/photoset/layouts/fitColumn/processors/align'
], function (ComplexNumber, Row, Balancer, Compresser, Aligner) {
    function Layout(jsonLayout) {
        this.items = jsonLayout.items;
        this.columnsCount = jsonLayout.columnsCount;
        this.offset = jsonLayout.offset;
        this.expand = jsonLayout.expand;

        this.processors = [
            new Balancer({ enable: this.expand, columnsCount: this.columnsCount }),
            new Compresser({ enable: this.expand }),
            new Aligner({ offset: this.offset, expand: this.expand })
        ];

        this._rows = ko.pureComputed(this._getRows, this).extend({ deferred: true });
        this.rows = ko.pureComputed(this._getProcessedRows, this).extend({ deferred: true });
    }

    Layout.prototype.apply = function () {
        var rows = this.rows(),
            offset = this.offset();

        ko.ignoreDependencies(function () {
            _(rows).reduce(function (rowOffset, row, rowIdx) {
                _(row.columns()).reduce(function (columnOffset, column, colIdx) {
                    _(column.items()).reduce(function (itemOffset, item) {
                        item.top(rowOffset.add(itemOffset));
                        item.left(columnOffset);
                        item.width(column.width());
                        item.isVisible(row.isVisible());
                        item.rowIdx(rowIdx);
                        item.colIdx(colIdx);

                        return itemOffset.add(item.height()).add(0, offset);
                    }, new ComplexNumber());

                    return columnOffset.add(column.width()).add(0, offset);
                }, new ComplexNumber());

                return rowOffset.add(row.height()).add(0, offset);
            }, new ComplexNumber());
        }, this);        
    };

    Layout.prototype._getRows = function () {
        _(this.items()).invoke('absWidth');
        _(this.items()).invoke('absHeight');

        return ko.ignoreDependencies(function (items, columnsCount, offset) {
            var rows = _(items).reduce(function (rows, item) {
                var row = _(rows).last();

                if (row === undefined || !row.canAdd(item)) {
                    row = new Row({ columnsCount: columnsCount, offset: offset });
                    rows.push(row);
                }

                row.append(item);

                return rows;
            }, [], this);

            _(rows).each(function (row) {
                var columns = row.columns();

                _(columns).each(function (column) {
                    column.width(new ComplexNumber(100 / columns.length));
                });
            });

            return rows;
        }, this, [this.items(), this.columnsCount(), this.offset()]);        
    };

    Layout.prototype._getProcessedRows = function () {
        var rows = this._rows();

        _(this.processors).invoke('process', rows);

        return rows;
    };

    return Layout;
});